import React, { Component } from 'react';
import services from '../../services/services';
import * as moment from 'moment';
import './index.scss';

import { allNotifications } from '../../utils/toastify'
const { notifyErrorBottomRight } = allNotifications

function Wrapper(Comp) {
  return class extends Component {
    state = {
      gtosListError: false,
      loading: false,
      procedimentos: [],
      procedures: [],
      gtosList: [],
      glosaCount: 0,
      gto: {
        benef: '',
        codBenef: 0,
        emissao: '',
        orcamento: 0
      }
    };

    updateStatusProcedimento = (status, index) => {
      const { procedures } = this.state;
      procedures[index].status = status;

      const glosaCount = this.glosaCounter(procedures);

      this.setState({
        glosaCount,
        procedures
      });
    };

    showResponseGto = showResponse => {
      const response = this.state.gtosList.filter(item => item[1].orcamento === showResponse);

      this.setState({
        procedimentos: response[0][1].allProceduresGTO,
        gto: {
          benef: response[0][1].benef,
          codBenef: response[0][1].codBenef,
          emissao: response[0][1].emissao,
          orcamento: response[0][1].orcamento
        }
      });
    };

    notify = message => {
      notifyErrorBottomRight(message);
    };

    fetchData = async () => {
      this.setState({ loading: true });

      const params = {
        codigoPrestador: this.props.codigoPrestador,
        codbenef: '0',
        dataFim: moment().format('YYYY-MM-DD'),
        dataIni: moment().format('YYYY-MM-DD')
      };

      try {
        const gtosList = await services.gto('getGTOsAll', params);
        this.setState(
          {
            gtosList,
            gtosListError: false
          },
          () => {
            if (this.props.location.params)
              this.showResponseGto(this.props.location.params.showResponse);
          }
        );
      } catch ({ message }) {
        this.setState({ gtosListError: true }, () => {
          this.notify('Não foi possível ir para esta GTO. Tente acessá-la através do menu Guias');
        });
      }

      this.setState({ loading: false });
    };

    glosaCounter = procedures =>
      procedures.reduce((acc, curr) => {
        if (curr.status === 'glosa') return acc + 1;
        return acc;
      }, 0);

    componentWillMount = () => {
      if (this.props.location.state !== undefined) {
        // const { benef , beneficiary, emissao, orcamento, procedures } = this.props.location.state[1];
        const { gtoId, idOdonto, procedures } = this.props.location.state;

        const glosaCount = this.glosaCounter(procedures);

        this.setState({
          procedures,
          glosaCount,
          // gto: { benef, beneficiary, emissao/*, orcamento */ }
          gto: { gtoId, idOdonto }
        });
      } else {
        this.fetchData();
      }
    };

    render() {
      return <Comp {...this.state} updateStatusProcedimento={this.updateStatusProcedimento} />;
    }
  };
}

export default Wrapper;
